export default "__VITE_ASSET__Bk7rzTCr__"